module.exports = __webpack_public_path__ + "img/web2.bfe077c7.png";